import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { App } from '@df/core/app';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { Subscription } from 'rxjs/internal/Subscription';
import { GiftcardsFormComponent } from '../module/giftcards/giftcards-form.component';
import { StoreCreditApplyComponent } from '../module/store-credit/apply/store-credit-apply.component';
import { IfStoreCreditCanBeUsedDirective } from '../module/store-credit/if-store-credit-can-be-used.directive';
import { StoreCreditService } from './../module/store-credit/store-credit.service';
import { CouponFormComponent } from './coupon-form.component';

@Component({
    selector: 'basket-discount-buttons',
    templateUrl: './basket-discount-buttons.html',
    standalone: true,
    imports: [
        CommonModule,
        CouponFormComponent,
        GiftcardsFormComponent,
        HideUpComponent,
        IfStoreCreditCanBeUsedDirective,
        StoreCreditApplyComponent,
        ToggleModule,
        TranslatePipe
    ]
})
export class BasketDiscountButtonsComponent implements OnInit, OnDestroy {
    @Input()
    context: 'basket' | 'checkout' | 'minibasket' = 'basket';

    readonly couponToggleId = 'coupon';
    readonly giftcardsToggleId = 'giftcard';

    protected subscriptions = new Subscription();

    constructor(
        protected app: App,
        protected changeDetectorRef: ChangeDetectorRef,
        protected storeCredit: StoreCreditService,
        protected toggleService: ToggleService
    ) {}

    ngOnInit() {
        this.subscriptions.add(this.app.customer.model.obs.data.subscribe(() => this.detectChanges()));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();

        this.toggleService.closeGroup(this.toggleGroup);
    }

    get storeCreditAdded(): boolean {
        return this.storeCredit.isAdded;
    }

    get displayCouponForm(): boolean {
        return !this.couponAdded || this.context !== 'checkout';
    }

    get isCheckout(): boolean {
        return this.context === 'checkout';
    }

    get couponAdded(): boolean {
        const coupon = this.app.customer.basket.data.coupon;

        if (coupon) {
            return !!(Array.isArray(coupon) ? coupon.length : coupon);
        }

        return false;
    }

    get toggleGroup(): NToggle.TGroupId {
        return this.context + 'Addons';
    }

    protected detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
